import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import EmployeesPage from "./pages/EmployeesPage";
import ConversationsPage from "./pages/ConversationsPage";
import ChurnPage from "./pages/ChurnPage";
import IssueMiningPage from "./pages/IssueMiningPage";
import AICoachPage from "./pages/AICoachPage";
import NLQueryPage from "./pages/NLQueryPage";
import UploadPage from "./pages/UploadPage";
import SettingsPage from "./pages/SettingsPage";
import AgentProfilePage from "./pages/AgentProfilePage";
import ConversationDetailPage from "./pages/ConversationDetailPage";
import HeartbeatPage from "./pages/HeartbeatPage";
import FeedbackPage from "./pages/FeedbackPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/employees" element={<EmployeesPage />} />
                <Route path="/employees/:agentId" element={<AgentProfilePage />} />
                <Route path="/conversations" element={<ConversationsPage />} />
                <Route path="/conversations/:conversationId" element={<ConversationDetailPage />} />
                <Route path="/churn" element={<ChurnPage />} />
                <Route path="/issues" element={<IssueMiningPage />} />
                <Route path="/heartbeat" element={<HeartbeatPage />} />
                <Route path="/coach" element={<AICoachPage />} />
                <Route path="/query" element={<NLQueryPage />} />
                <Route path="/upload" element={<UploadPage />} />
                <Route path="/feedbacks" element={<FeedbackPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: { background: "#1e293b", color: "#f8fafc", borderRadius: "12px" },
          }}
        />
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}
